
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { TypeGuide, ApiGateway } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class TypeGuideEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    typeGuide: TypeGuide;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getTypeGuide()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getTypeGuide(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.typeGuide = data;
                this.onDataChanged.next(this.typeGuide);
                resolve(this.typeGuide);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('typeGuide/' + this.routeParams.id).subscribe((res: TypeGuide ) => {
                    this.typeGuide = res;
                    this.onDataChanged.next(this.typeGuide);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(typeGuide): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('typeGuide/', typeGuide).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(typeGuide): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('typeGuide/', typeGuide).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(typeGuide): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('typeGuide/' + typeGuide.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    checkLastModifications(): TypeGuide {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
